module.exports = __webpack_public_path__ + "static/media/night_profile_background.a743ae71.jpg";